import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LgpdService } from 'src/app/service/lgpd/lgpd.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { CadastroUsuario } from 'src/app/entity/CadastroUsuario';
import { RepresentanteLegalLgpdComponent } from '../representante-legal/representante-legal-lgpd.component';
import { TitularDadosLgpdComponent } from '../titular-dados/titular-dados-lgpd.component';
import { Validators } from '@angular/forms';

@Component({
  selector: 'solicitacoes-informacoes-lgpd',
  templateUrl: './solicitacoes-informacoes-lgpd.component.html',
  styleUrls: ['./solicitacoes-informacoes-lgpd.component.css']
})
export class SolicitacoesInformacoesLgpdComponent implements OnInit {

  @Input() usuario: string;
  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  @Input() RGT: any[];
  @Input() RGR: any[];
  @Input() CRGT: any[];
  @Input() CRGR: any[];
  @Input() PR: any[];
  @ViewChild(TitularDadosLgpdComponent, { static: false }) titularDados: TitularDadosLgpdComponent;
  @ViewChild(RepresentanteLegalLgpdComponent, { static: false }) representanteLegal: RepresentanteLegalLgpdComponent;
  requerente: CadastroUsuario;
  listaClassificacaoComponente = [];
  charNum = 5000;

  constructor(
    public service: LgpdService,
    private desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) { }

  ngOnInit() {
    // this.preencherListaClassificacao();
    if(!this.visualizacao) {
      this.carregarRequerente()
    }
    this.service.lgpd.get('retorno').valueChanges
      .subscribe(retorno => this.toggleRetornoValidator(retorno))
  }

  carregarRequerente() {
    if (this.usuario == 'externo') { this.requerente = this.authService.usuarioLogado }
    else {
      this.service.lgpd.get('nome').setValue(null);
      this.service.lgpd.get('cpf').setValue(null);
      this.service.lgpd.get('dataNascimento').setValue(null);
      this.service.lgpd.get('email').setValue(null);
    }
  }

  limparFormulario() {
    // this.service.lgpd.get('requerente').setValue(null);
    // this.service.lgpd.get('nome').setValue(null);
    // this.service.lgpd.get('cpf').setValue(null);
    // this.service.lgpd.get('dataNascimento').setValue(null);
    // this.service.lgpd.get('email').setValue(null);
    this.service.lgpd.get('demanda').setValue(null);
    this.service.lgpd.get('retorno').setValue(null);
    this.service.lgpd.get('emailRetorno').setValue(null);
    this.service.lgpd.get('endereco').setValue(null);
    this.service.lgpd.get('cep').setValue(null);
    this.service.lgpd.get('identificacaoTitular').setValue(null);
    this.service.lgpd.get('fotoRequerente').setValue(null);
    this.service.lgpd.get('documentoLegal').setValue(null);
    this.service.lgpd.get('descricaoLgpd').setValue(null);
    this.service.lgpd.get('numeroProcessoSEI').setValue(null);
    this.service.lgpd.controls.representanteLegal.get('nome').setValue(null);
    this.service.lgpd.controls.representanteLegal.get('cpf').setValue(null);
    this.service.lgpd.controls.representanteLegal.get('dataNascimento').setValue(null);
    this.service.lgpd.controls.representanteLegal.get('email').setValue(null);
    this.service.lgpd.controls.representanteLegal.clearValidators();
  }

  toggleRetornoValidator(retorno: string) {
    // Se o retorno for por email, o emailRetorno deve ser obrigatório
    if (!this.visualizacao && retorno == "Email") {
      this.service.lgpd.get('emailRetorno').setValidators(Validators.required)
      this.service.lgpd.get('emailRetorno').setValue(this.requerente ? this.requerente.email : this.service.lgpd.get('email').value)

      this.service.lgpd.get('endereco').setValidators(null)
      this.service.lgpd.get('endereco').setValue(null)

      this.service.lgpd.get('cep').setValidators(null)
      this.service.lgpd.get('cep').setValue(null)
    }
    // Se o retorno for por carta, os campos endereco e cep devem ser preenchidos
    else if (!this.visualizacao && retorno == "Carta") {
      this.service.lgpd.get('emailRetorno').setValidators(null)
      this.service.lgpd.get('emailRetorno').setValue(null)

      this.service.lgpd.get('endereco').setValidators(Validators.required)
      this.service.lgpd.get('endereco').setValue(this.requerente ? this.requerente.logradouro : null)

      this.service.lgpd.get('cep').setValidators(Validators.required)
      this.service.lgpd.get('cep').setValue(this.requerente ? this.requerente.cep : null)
    }
  }

  toggleRepresentanteValidator(event) {
    this.limparFormulario()
    // Se o requerente for o titular dos dados, os dados pessoais do representante legal não são obrigatórios
    if (event.target.value == 'Titular dos Dados') {
      this.service.lgpd.controls.representanteLegal.get('nome').clearValidators()
      this.service.lgpd.controls.representanteLegal.get('cpf').clearValidators()
      this.service.lgpd.controls.representanteLegal.get('dataNascimento').clearValidators()
      this.service.lgpd.controls.representanteLegal.get('email').clearValidators()
    }
    // Se o requerente for o representante legal, os dados pessoais do representante legal são obrigatórios
    else if (event.target.value == 'Representante Legal') {
      this.service.lgpd.controls.representanteLegal.setValidators(Validators.required);
      this.service.lgpd.controls.representanteLegal.get('nome').setValidators(Validators.required)
      this.service.lgpd.controls.representanteLegal.get('cpf').setValidators([Validators.required, Validators.minLength(11)])
      this.service.lgpd.controls.representanteLegal.get('dataNascimento').setValidators(Validators.required)
      this.service.lgpd.controls.representanteLegal.get('email').setValidators(Validators.required)
    }
    this.service.lgpd.controls.representanteLegal.get('nome').updateValueAndValidity()
    this.service.lgpd.controls.representanteLegal.get('cpf').updateValueAndValidity()
    this.service.lgpd.controls.representanteLegal.get('dataNascimento').updateValueAndValidity()
    this.service.lgpd.controls.representanteLegal.get('email').updateValueAndValidity()
  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.lgpd.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.lgpd.value.assunto.id);
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.lgpd.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.lgpd.controls[str].touched &&
      this.service.lgpd.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

}
